import { render, staticRenderFns } from "./CompareShare.vue?vue&type=template&id=58e9e3fa&scoped=true&"
import script from "./CompareShare.vue?vue&type=script&lang=js&"
export * from "./CompareShare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e9e3fa",
  null
  
)

export default component.exports